// FUNÇÕES/MÓDULOS SITE
import HoverBackgroundGradient from './modules/Animation/hover_bg-gradient'
import ScrollSmooth from './modules/Animation/scrollLenis'
import AnimationElements  from './modules/Animation/enterElements'
import Footer from './modules/Layouts/footer'
import AnchorLinks from './modules/Utils/anchor_links'
import ImageEnter from './modules/Animation/imageEnter'
import ImagesHovers from './modules/Animation/imageHovers'
import removeEmptyImg from './modules/Utils/removeEmptyImg'
import bootstrapForms from './modules/Forms/bootstrapForms'
import infinityText from './modules/Animation/infinityText'
import Menu from './modules/Layouts/menu'

//aplica display: none em imagens sem src/sem cadastro
removeEmptyImg();
//forms
bootstrapForms();

// Animations
ScrollSmooth()
infinityText();
AnimationElements()
HoverBackgroundGradient()
ImageEnter()
ImagesHovers()

// Utils
AnchorLinks()

// Layout
Menu()
Footer()